<script>
import MaterialSymbolsLightPermMediaOutline from './MaterialSymbolsLightPermMediaOutline.vue';
import PhAddressBook from './PhAddressBook.vue';
import PhCalendar from './PhCalendar.vue';
import PhChatsCircle from './PhChatsCircle.vue';
import PhCube from './PhCube.vue';
import PhEnvelope from './PhEnvelope.vue';
import PhFolder from './PhFolder.vue';
import PhHouseLine from './PhHouseLine.vue';
import PhIdentificationCard from './PhIdentificationCard.vue';
import PhKanban from './PhKanban.vue';
import PhMoney from './PhMoney.vue';
import PhPaperPlaneTilt from './PhPaperPlaneTilt.vue';
import PhRobot from './PhRobot.vue';
import PhUsersFour from './PhUsersFour.vue';

export default {
  components: {
    PhMoney,
    PhUsersFour,
    PhKanban,
    PhIdentificationCard,
    PhCalendar,
    PhCube,
    PhRobot,
    PhHouseLine,
    PhFolder,
    PhAddressBook,
    MaterialSymbolsLightPermMediaOutline,
    PhPaperPlaneTilt,
    PhEnvelope,
    PhChatsCircle,
  },
  computed: {
    navigation() {
      const currentInstance = this;
      function hasPermission(permission) {
        return currentInstance.$membershipHasPermissionTo(permission);
      }
      function isAdminOrSuperAdmin() {
        return currentInstance.$isAdminOrSuperAdmin;
      }

      const accountId = this.$currentAccount.id;

      const items = [
        {
          items: [
            {
              name: 'Home',
              to: { name: 'accounts.show', params: { accountId } },
              icon: PhHouseLine,
              exact: true,
            },
            {
              name: 'My Projects',
              to: { name: 'accounts.projects', params: { accountId } },
              icon: PhFolder,
              show: () => hasPermission('read projects'),
            },
            {
              name: 'My Contacts',
              to: { name: 'accounts.accountId.contacts', params: { accountId } },
              icon: PhAddressBook,
              show: () => hasPermission('read contacts'),
            },
            {
              name: 'My Contact Requests',
              to: { name: 'accounts.accountId.contactRequests', params: { accountId } },
              icon: PhUsersFour,
              show: () => hasPermission('read contact requests'),
            },
            {
              name: 'My Contact Requests (NEW)',
              href: `/c/${accountId}/contact-requests`,
              icon: PhUsersFour,
              show: () => hasPermission('read contact requests') || isAdminOrSuperAdmin(),
            },
            {
              name: 'My Pipelines',
              to: { name: 'accounts.pipelines', params: { accountId } },
              icon: PhKanban,
              show: () => hasPermission('read pipelines'),
            },
            {
              name: 'Αρχεία',
              to: { name: 'accounts.accountId.assets', params: { accountId } },
              icon: MaterialSymbolsLightPermMediaOutline,
              show: () => hasPermission('read assets'),
            },
            {
              name: 'Calendar',
              to: { name: 'accounts.calendar', params: { accountId } },
              icon: PhCalendar,
            },
            {
              name: 'Email Campaigns',
              to: { name: 'accounts.accountId.emailCampaigns', params: { accountId } },
              icon: PhPaperPlaneTilt,
              show: () => hasPermission('read email campaigns'),
            },
            {
              name: 'Email Templates',
              to: { name: 'accounts.accountId.emailTemplates', params: { accountId } },
              icon: PhEnvelope,
              show: () => hasPermission('read email templates'),
            },
            {
              name: 'SMS Campaigns',
              to: { name: 'accounts.accountId.smsCampaigns', params: { accountId } },
              icon: PhChatsCircle,
              show: () => hasPermission('read sms campaigns'),
            },
          ],
        },
      ];

      return items;
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-full flex-1 bg-gray-900">
    <div class="flex-1 flex flex-col pb-4 overflow-y-auto pt-8">
      <RouterLink
        v-if="$currentAccount.logo"
        :to="{ name: 'accounts.show', params: { accountId: $currentAccount.id } }"
      >
        <img :src="$currentAccount.logo" class="block rounded w-24 mb-8 mx-auto" />
      </RouterLink>
      <h6 class="text-center text-white mb-6">
        {{ $currentAccount.name }}
      </h6>
      <div class="px-6">
        <nav class="flex flex-1 flex-col">
          <ul role="list" class="flex flex-1 flex-col gap-y-7">
            <li v-for="(group, groupIdx) in navigation" :key="groupIdx">
              <div v-if="group.name" class="text-xs font-semibold leading-6 text-gray-400">
                {{ group.name }}
              </div>
              <ul role="list" class="-mx-2 space-y-1">
                <template v-for="item in group.items">
                  <li v-if="(item.show || (() => true))()" :key="item.name">
                    <RouterLink
                      v-if="item.to"
                      :to="item.to"
                      custom
                      v-slot="{ isActive, isExactActive, href, navigate }"
                    >
                      <a
                        :href="href"
                        :class="[
                          (item.exact ? isExactActive : isActive)
                            ? 'bg-gray-800 text-white'
                            : 'text-gray-400 hover:text-white hover:bg-gray-800',
                          'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold transition-colors',
                        ]"
                        @click="navigate"
                      >
                        <component
                          v-if="item.icon"
                          :is="item.icon"
                          class="h-6 w-6 shrink-0"
                          aria-hidden="true"
                        />
                        {{ item.name }}
                      </a>
                    </RouterLink>
                    <a
                      v-if="item.href"
                      :href="item.href"
                      :class="[
                        'text-gray-400 hover:text-white hover:bg-gray-800 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold transition-colors',
                      ]"
                    >
                      <component
                        v-if="item.icon"
                        :is="item.icon"
                        class="h-6 w-6 shrink-0"
                        aria-hidden="true"
                      />
                      {{ item.name }}
                    </a>
                  </li>
                </template>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>
